import React, { ReactElement } from "react";
import {
    GradeAccordionImageGalleryProps,
    GradeAccordionProps
} from "../../types/GradeAccordionProps";
import { Accordion, AccordionTab } from "primereact/accordion";
import { NotableItems } from "../NotableItems/NotableItems";

const ACCORDION_TAB_ENUM: { [name: number]: string } = {};

export const GradeAccordion = (props: GradeAccordionProps): ReactElement => {
    const handleTabOpen = (index: number) => {
        const tabName = ACCORDION_TAB_ENUM[index];

        if (tabName && props.sendAnalyticsEvent) {
            props.sendAnalyticsEvent(`grading_${tabName}_accordion`);
        }
    };

    const showImageGallery = (
        imageGallery?: GradeAccordionImageGalleryProps
    ) => {
        if (!props.showImageGallery || !imageGallery?.component) {
            return <></>;
        }

        return <>{imageGallery.component}</>;
    };

    return (
        <Accordion onTabOpen={(e) => handleTabOpen(e.index)} multiple>
            {props.tabs.map((tab, index) => {
                ACCORDION_TAB_ENUM[index] = tab.name;

                return (
                    <AccordionTab
                        tabIndex={index}
                        key={tab.name}
                        headerTemplate={props.accordionTabStyle(
                            tab.name,
                            tab.score
                        )}
                    >
                        <div className="flex justify-content-between align-items-center">
                            <p>{tab.summaryText}</p>
                            {showImageGallery(tab.imageGallery)}
                        </div>
                        {tab.conditionSummary !== undefined &&
                            tab.notableItems.length > 0 && (
                                <NotableItems
                                    notableItems={tab.notableItems}
                                    sendAnalyticsEvent={
                                        props.sendAnalyticsEvent
                                    }
                                    showImageGrid={true}
                                />
                            )}
                    </AccordionTab>
                );
            })}
        </Accordion>
    );
};
